import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Col } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import '../index.css';

const SingleCaseStudy = ({ work }) => {
  return (
    <Col className='single-project my-3' xs={12} md={6} lg={4}>
      <Fade bottom>
        <div className='case-study-card'>
          <a
            className='case-study-link'
            href={work.website}
            rel='noopener noreferrer'
            target='_blank'
          >
            <FontAwesomeIcon
              className='work-icon'
              title='Visit Website'
              icon={faExternalLinkAlt}
            />
          </a>

          <h4 className='project-name py-2'>{work.name}</h4>
          <p className='case-study-role'>{work.role}</p>
          <p className='project-description'>{work.description}</p>

          <div className='case-study-metrics'>
            {work.metrics.map((metric, index) => (
              <p className='case-study-metric' key={index}>
                {metric}
              </p>
            ))}
          </div>

          <div className='technologies-row d-flex flex-wrap'>
            {work.technologies.map((item, index) => (
              <div className='technologies m-1' key={index}>
                {item.name}
              </div>
            ))}
          </div>
        </div>
      </Fade>
    </Col>
  );
};

export default SingleCaseStudy;
